import script from "./BorderLine.vue?vue&type=script&lang=ts&setup=true"
export * from "./BorderLine.vue?vue&type=script&lang=ts&setup=true"

import "./BorderLine.vue?vue&type=style&index=0&id=7170d1be&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7170d1be"]])

export default __exports__